import { useEffect, useState } from 'react'
import { Form, Modal } from 'react-bootstrap'
import ApiRoutes from 'assets/js/classes/ApiRoutes'
import Submitter from 'assets/js/classes/Submitter'
import { AxiosMethods } from 'assets/js/utilities/axios'
import SubmitBtn from 'components/forms/SubmitBtn'
import ConfirmationAlert from 'components/ui/ConfirmationAlert'
import ValidationAlert from 'components/ui/ValidationAlert'
import { stateUpdateSubmitBtn, useSubmitBtnDispatch, useSubmitBtnState } from 'contexts/SubmitBtnContext'
import { stateUpdateClientEmailModal, useTaskModalDispatch, useTaskModalState } from 'contexts/TaskModalContext'
import { useTenantState } from 'contexts/TenantContext'

export default function SendEmailForm({ task }) {
  // CONTEXT - TASK MODAL
  const { showClientEmailModal } = useTaskModalState();
  const taskModalDispatch = useTaskModalDispatch();

  // CONTEXT - TENANT
  const { tenant } = useTenantState();

  // CONTEXT - SUBMIT BUTTON
  const { btnState, response } = useSubmitBtnState();
  const submitBtnDispatch = useSubmitBtnDispatch();
  
  // STATE PARAMS
  const [message, setMessage] = useState('');

  // VALIDATION PARAMS
  const [formValidated, setFormValidated] = useState(false);
  const [showValidationAlert, setShowValidationAlert] = useState(false);
  const [validationMessage, setValidationMessage] = useState(null);
  
  // CONFIRMATION PARAMS
  const [confirmationMessage, setConfirmationMessage] = useState({});

  const sendNotification = async e => {
    e.preventDefault();

    setConfirmationMessage({});

    const submitter = new Submitter(e, 
      { stateUpdateSubmitBtn, submitBtnDispatch }, 
      { method: AxiosMethods.POST, route: ApiRoutes.TASK_EMAIL(task?.id) });

    await submitter.validate({setFormValidated, setShowValidationAlert, setValidationMessage});

    if (submitter.success) {
      setConfirmationMessage({
        title: 'Success',
        body: `Message sent to ${submitter.response?.data?.recipient?.email}.`,
      });
    } else {
      setConfirmationMessage({});
    }
  }
  
  useEffect(() => {
    setMessage(
      `Dear ${task?.client?.name},\n\n` +
      `This is an update for your request #${task?.id} (Status: ${task?.status}).\n\n` +
      `Regards,\n` +
      `${tenant?.name}`
    );
  }, [task, tenant]);

  return (
    <Modal 
      id="ModalSendEmail" 
      show={showClientEmailModal} 
      onHide={() => stateUpdateClientEmailModal(taskModalDispatch, { showClientEmailModal: false })} 
      size="lg" 
      keyboard={true}
    >
      <Modal.Header closeButton className="bg-white align-items-center">
        <Modal.Title className="flex-fill">
          Email Notification to {task?.client?.email}
        </Modal.Title>
      </Modal.Header>

      <Form 
        autoComplete="off" 
        onSubmit={sendNotification} 
        noValidate
        validated={formValidated}
      >
        <Modal.Body>
          <Form.Control 
            as="textarea" 
            className="mb-3"
            style={{height: '18rem'}}
            value={message}
            name="message"
            placeholder="Notification message..."
            onChange={e => setMessage(e.target.value)}
            required
          />
          
          <ValidationAlert 
            showValidationAlert={showValidationAlert} 
            validationMessage={validationMessage} />

          <ConfirmationAlert className="mb-1" message={confirmationMessage} />  

        </Modal.Body>

        <Modal.Footer>  
          <SubmitBtn 
            disabled={message.length === 0}
            icon={['far', 'paper-plane']}
            loadStatus="Sending Email ..."
            response={response} 
            state={btnState}
            text="Send Email Notification"
          />
        </Modal.Footer>
      </Form>
    </Modal>
  )
}